<template>


<van-nav-bar class="config-header">
  <template #left>
   
    <h3 class="align-left header_title">

     <span class="font-norm"> {{ $t('CONFIGURATEUR') }} </span>


     {{ $t('LIEN FIBRE OPTIQUE PRÉCONNECTORISÉ') }}
    </h3>
   
    <!-- <h2>{{ $t('message') }}</h2>  -->
  </template>
  <template #title>
  
  </template>
  <template #right>

<!--
  <van-icon v-if="getEnvironnementWeb != 'Webshop'" @click="showPopup" class="icon-panier" name="cart-o" size="30" badge="4"/>
-->

  <van-image
  v-if="getEnvironnementWeb == 'Webshop'"
    :show-loading = false
      width="11rem"
      fit="contain"
      src="https://admin-fibre.gigamedia.net/images/logo/logo-GGM-SmartBS-bleu.svg"
    />

<!--
  
  <van-image
  v-bind:class="{ pays_select: langFr}" 
  class="icon-lang"
  @click="changeLang('fr')"
  round
  width="30"
  margin-left="40"
  height="30"
  src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_France_%281794%E2%80%931815%2C_1830%E2%80%931974%2C_2020%E2%80%93present%29.svg/langfr-225px-Flag_of_France_%281794%E2%80%931815%2C_1830%E2%80%931974%2C_2020%E2%80%93present%29.svg.png"
/>


<van-image
v-bind:class="{ pays_select: langEn}" 
class="icon-lang"
@click="changeLang('en')"
  round
  width="30"
  height="30"
  src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg/langfr-225px-Flag_of_the_United_Kingdom_%283-5%29.svg.png"
/>

-->

<!--
    <select v-model="$i18n.locale">
        <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
         {{ lang }}
         </option>
    </select>
-->
  </template>
</van-nav-bar>


<van-popup  round v-model:show="showPanier" closeable  position="bottom" :style="{ height: '90%' }">
    
 

<van-divider
  :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 80px' }"
>
Panier
</van-divider>

<van-search
  v-model="value"
  shape="round"
  show-action
  placeholder="Ajout Ref Devis"
  @search="onSearch"
>
  <template #action>
    <div @click="onClickButton">go</div>
  </template>
</van-search>

<van-list
  v-model:loading="loading"
  :finished="finished"
  finished-text="Finished"
  @load="onLoad"
>
  <van-cell v-for="item in list" :key="item" :title="item" />
</van-list>


<van-pagination v-model="currentPage" :total-items="50" :show-page-size="5">
  <template #prev-text>
    <van-icon name="arrow-left" />
  </template>
  <template #next-text>
    <van-icon name="arrow" />
  </template>
  <template #page="{ text }">{{ text }}</template>
</van-pagination>



</van-popup>


</template>

<script>
export default {
    name: 'Header',
    data() {
    return {
        langFr: true,
        langEn: false,
        showPanier: false,
        list : ['Configuration du 02/08/2022','Configuration du 23/05/2022'],
        currentPage: 1
    }
  },
  computed: {
      getEnvironnementWeb(){
        return this.$store.state.storeGlobal.StoreEnvWeb
      }
  },
  mounted(){
    
      if( this.$i18n.locale == 'fr' ){
        this.changeLang('fr')
      }else{
        this.changeLang('en')
      }
  },
  methods: {
    showPopup() {
    
        this.showPanier = true
        },
    changeLang(lang) {
      this.$i18n.locale = lang  
        if(lang == 'fr'){ 
            this.langFr = true 
            this.langEn = false 
        }
        if(lang == 'en'){ 
            this.langEn = true
            this.langFr = false 
        }
       
    },
}
}
</script>

<style>
.config-header {
  background: #ffffff00 !important;;
  padding:10px;
  z-index: 9999 !important;
}
.config-header .van-nav-bar__content {
  height: 3vh;
}

  .icon-lang{
    margin-right:8px;
  }
  .icon-panier{
    margin-right:30px;
    color:rgba(1, 69, 140, 1.000) !important;
  }
  .pays_select{
    box-shadow: 0px 0px 3px 2px black;
  }
</style>